import { IOfferCard } from '../../../types';

export const isFromBuilder = ({ newbuilding }: IOfferCard) => Boolean(newbuilding && newbuilding.isFromBuilder);
